// import ChartV5 from '../../pages/apruebo-rechazo/ChartV5';
import ChartApi from '../../../pages/apruebo-rechazo/apruebo-rechazo-v3/ChartApi';

const MainCP = () => {
  return (
    <div className="container-fluid">
      <div className="row" style={{ marginTop: '40px' }}>
        <div className="col-12">
          <div className="d-flex justify-content-center">
            {/* <ChartV5 /> */}
            <ChartApi customSize={1}/>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MainCP;
